import { C, P0, R, S, abs, core, disc, max, moodK } from '../../geometry';

export const chevrons = {
  name: 'Chevrons',
  colors: ['#E5484D', '#3E63DD'],
  draw(m, t) {
    let spin = 0,
      inward = false,
      pose = P0();
    const dist = (i) => {
      if (m === 'happy') return 30 + 4 * abs(S(t * 7 + i));
      // Thinking: the chevrons pulse outward in turn, like radar.
      if (m === 'thinking') return 26 + 7 * (0.5 + 0.5 * S(t * 5 - i * 1.57));
      if (m === 'talking') return 28 + 3 * max(0, S(t * 10));
      if (m === 'surprised') return 37;
      if (m === 'paused') return 31;
      return 28 + 0.6 * S(t * 1.6 + i);
    };
    if (m === 'thinking') spin = t * 15;
    if (m === 'happy') pose.ty = -2 * abs(S(t * 6));
    if (m === 'paused') inward = true;
    return {
      strokes: [0, 1, 2, 3].map((i) => {
        const a = (i * 90 - 90) * R,
          d = dist(i),
          dir = [C(a), S(a)],
          per = [-S(a), C(a)],
          tip = inward ? d - 6 : d + 6;
        return {
          c: i % 2 ? 'b' : 'a',
          pts: [
            [50 + dir[0] * d + per[0] * 7, 52 + dir[1] * d + per[1] * 7],
            [50 + dir[0] * tip, 52 + dir[1] * tip],
            [50 + dir[0] * d - per[0] * 7, 52 + dir[1] * d - per[1] * 7],
          ],
          sharp: true,
          n: 24,
          spin,
        };
      }),
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(core(disc(50, 52, 17 * moodK(m, t))));
    return f;
  },
};
